import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';

const getWarehouseExist = createAsyncThunk(
  'general/getWarehouseExist',
  async (mpn, { rejectWithValue }) => {
    try {
      const { data } = await authGet('/general/check/warehouse', {
        params: {
          mpn
        }
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const clearWarehouseExist = createAction('clearWarehouseExist');

export default getWarehouseExist;
